
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M2.334 3.333h35.333v3.333H2.334zm0 30h35.333v3.333H2.334zm22.869-18.435v-4.16H14.815v18.527h4.16v-8.13h6.228v-4.16h-6.228v-2.077zm2.075-4.164v18.531h4.16v-8.13h6.228v-4.16h-6.228v-2.077h6.228v-4.16H27.278zM4.415 29.265h6.24a2.086 2.086 0 002.08-2.08v-14.37a2.086 2.086 0 00-2.08-2.08h-6.24a2.086 2.086 0 00-2.082 2.08v14.37a2.086 2.086 0 002.082 2.08zm2.08-14.37h2.08v10.21h-2.08z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      